import React, { createContext, Dispatch, FC, ReactNode, useReducer } from 'react';

export interface BienvenueState {
  isSubmittingForm: boolean;
}

export const initialBienvenueState: BienvenueState = {
  isSubmittingForm: false,
};

export type Action = { type: 'START_SUBMIT' } | { type: 'CANCEL_SUBMIT' } | { type: 'END_SUBMIT' };

export function bienvenueReducer(state: BienvenueState, action: Action): BienvenueState {
  switch (action.type) {
    case 'START_SUBMIT':
      return { ...state, isSubmittingForm: true };
    case 'CANCEL_SUBMIT':
      return { ...state, isSubmittingForm: false };
    case 'END_SUBMIT': {
      return {
        ...state,
        isSubmittingForm: false,
      };
    }
  }
}

export const BienvenueContext = createContext<{
  state: BienvenueState;
  dispatch: Dispatch<Action>;
}>({
  state: initialBienvenueState,
  dispatch: () => initialBienvenueState,
});

export const BienvenueProvider: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [state, dispatch] = useReducer(bienvenueReducer, initialBienvenueState);

  return (
    <BienvenueContext.Provider value={{ state, dispatch }}>{children}</BienvenueContext.Provider>
  );
};
